import { render, staticRenderFns } from "./ItemInventory.vue?vue&type=template&id=524ddf10"
import script from "./ItemInventory.vue?vue&type=script&lang=js"
export * from "./ItemInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports